(function($) {
    /*var featuredinId = $('#FeaturedInSection > .e-con-inner');
        featuredinId.addClass('swiper-wrapper');*/
    var slides = [];
    $('#FeaturedInSection .swiper-wrapper .swiper-slide').each(function(idx, slide){
      console.log($(slide).data());
      var img_el = $(slide).children(0).children(0);
      var img_slide = '';
      var img_attributes = img_el.prop("attributes");
      $.each(img_attributes, function() {
        if(this.name == 'src'){
          img_slide = img_slide + ' src="' + this.value + '" ';
        }
        if(this.name == 'width'){
          img_slide = img_slide + ' width="' + this.value + '" ';
        }
        if(this.name == 'height'){
          img_slide = img_slide + ' height="' + this.value + '" ';
        }
        if(this.name == 'sizes'){
          img_slide = img_slide + ' sizes="' + this.value + '" ';
        }
      });
      img_slide = img_slide + ' class="attachment-full size-full" ';
      slides.push(
        '<div class="swiper-slide">' + 
         '<img loading="lazy" decoding="async" '+ img_slide + ' />' +
        '</div>'
      );
    });
    $('#FeaturedInSection .swiper-wrapper').html('');
    for(var ii=1;ii<=3;ii++){
      $.each(slides,function(idx, slide){
        $('#FeaturedInSection .swiper-wrapper').append(slide);
      });
      
    }
    var featuredin = new Swiper('#FeaturedInSection', {
        spaceBetween: 0,
        centeredSlides: false,
        speed: 12000,
        roundLengths: true,
        autoplay: {
          delay: 1
        },
        loop: true,
        slidesPerView:'auto',
        allowTouchMove: false,
        disableOnInteraction: true,
      });
      $('#FeaturedInSection  .swiper-wrapper > .swiper-slide').on('mouseenter', function(e){
        featuredin.autoplay.stop();
        console.log('slider stopped');
      });
      $('#FeaturedInSection  .swiper-wrapper > .swiper-slide').on('mouseleave', function(e){
        featuredin.autoplay.start();
        console.log('slider started again');
      });

      var majorInuranceAcceptedSlides = [];

      function Observer(o, property){
        var _this = this;
        var value = o[property];
        this.observers = [];
        
        this.Observe = function (notifyCallback){
            _this.observers.push(notifyCallback);
        }
        
        Object.defineProperty(o, property, {
            set: function(val){
                _this.value = val;
                for(var i = 0; i < _this.observers.length; i++) _this.observers[i](val);
            },
            get: function(){
                return _this.value;
            }
        });
      }
        //var mutationTarget = document.querySelector('.example');
        //var ss_settings = JSON.parse(JSON.stringify($('#staffCarouselNew').data('settings')));
        //$('#staffCarouselNew').data('settings','');
        //ss_settings.centered_slides = 'yes';
        //$('#staffCarouselNew').attr('data-settings',JSON.stringify(ss_settings));
        //$('#staffCarouselNew').data('settings',ss_settings);
        //console.log($('#staffCarouselNew').data('settings'));
        const staffCarouselNewSwiper = document.querySelector("#staffCarouselNew .elementor-main-swiper.swiper");
        var quotes = [];
        $('#staffCarouselNew .elementor-main-swiper.swiper .swiper-wrapper .swiper-slide').each(function(idx, quote){
          var quote = $(quote).find('.elementor-testimonial__text').text();
          quotes.push(quote);
        });
        var mutationObserverConfig = { attributes: true };
        var ssw;
        var callback = function ( mutations ) {
          for( var mutation of mutations ) {
            if ( mutation.attributeName === 'class' ) {
              if ( mutation.target.classList.contains('swiper-initialized') ) {
                //console.log(mutation.target.classList.value);
                setTimeout(() => {
                  const ss = $(staffCarouselNewSwiper);
                  ssw = ss.data('swiper');
                  ssw.params.centeredSlides = true;
                  ssw.params.roundLengths = true;
                  //ssw.params.loopAdditionalSlides = 30,
                  ssw.update();
                  ssw.on('transitionEnd', function() {
                    //console.log('*** mySwiper.realIndex', quotes[ssw.realIndex]);
                    $('#staffquotesection .quote-wrapper .quote').hide().html(quotes[ssw.realIndex]).fadeIn('slow');
                  });
                }, 10);
              }
            }
          }
        };
        if($('#staffCarouselNew').length){
          var observer = new MutationObserver ( callback );
          observer.observe (staffCarouselNewSwiper, mutationObserverConfig );
          $('#staffCarouselNew').after('<div class="staff-quote" id="staffquotesection"><div class="quote-wrapper"><span class="quote">'+quotes[0]+'</span></div></div>');
        }

        //console.log($(staffCarouselNewSwiper));
        //var observer = new Observer(staffCarouselNewSwiper, 'swiper');
        //observer.Observe(function(newValue){
          //const ss = $(newValue);
          //const ssw = ss.data('swiper');
          //console.log($(ssw));
          /*const swiperNeigh = newValue;
          if (swiperNeigh) {
              //swiperNeigh.on('click', clickSwiper);
              const ss = $(swiperNeigh);
              const ssw = ss.data('swiper');
              ssw.params.centeredSlides = true;
              ssw.update();
          } */
      //});
      //var staffCarouselNewSwiper = document.getElementById('staffCarouselNew').swiper;
      //const staffCarouselNewSwiper = $('#staffCarouselNew .elementor-main-swiper.swiper');
      //staffCarouselNewSwiper
      /*console.log(staffCarouselNewSwiper);
      console.log(staffCarouselNewSwiper.data('swiper'));
      console.log(staffCarouselNewSwiper.children(0).children(1));
      console.log(staffCarouselNewSwiper.children(0).children(1).children(0));
      console.log('swiper: ', staffCarouselNewSwiper.children(0).children(1).children(0).swiper);*/
      //const staffSwiper = staffCarouselNewSwiper.data('swiper');
      //setTimeout(() => {
        //const ss = $(staffCarouselNewSwiper);
        //const ssw = ss.data('swiper');
        //ssw.params.centeredSlides = true;
        //ssw.update();
      //}, 500);
      
      
     //console.log($(staffCarouselNewSwiper));
     //staffSwiper.destroy();
     //staffSwiper.update();
      //staffSwiper.destroy();
      //staffCarouselNewSwiper = undefined;
        //jQuery('#staffCarouselNew > .elementor-widget-container > .elementor-swiper > .elementor-main-swiper.swiper > .swiper-wrapper').removeAttr('style');
        //jQuery('#staffCarouselNew > .elementor-widget-container > .elementor-swiper > .elementor-main-swiper.swiper > .swiper-wrapper .swiper-slide').removeAttr('style');   
      /*var staffImageCarousel = new Swiper(staffCarouselNewID.children(0), {
        spaceBetween: 1,
        slidesPerView: 3,
        centeredSlides: true,
        roundLengths: true,
        loop: true,
        loopAdditionalSlides: 30,
        navigation: {
          nextEl: ".elementor-swiper-button-next",
          prevEl: ".elementor-swiper-button-prev"
        }
      });*/

      const shuffle = (array) => {
        for (let i = array.length - 1; i > 0; i--) { 
          const j = Math.floor(Math.random() * (i + 1)); 
          [array[i], array[j]] = [array[j], array[i]]; 
        } 
        return array; 
        }; 

      const leftTags = [];
      const rightTags = [];
      const mobileTags = [];
      //console.log('hidden? ', $('.why-consider-treatment-tagcloud').is(':hidden'));
      //if ($(window).width() >= 1024){
      if($('.why-consider-treatment-tagcloud2').length){
        if(!$('.why-consider-treatment-tagcloud2').is(':hidden')){
          $('.why-consider-treatment-tagcloud2 .left-container-scroll').find('h3').each(function(){
            if($(this).width() > 0){
              leftTags.push('<h3 style="color:'+$(this).css('color')+';font-size:22px;font-weight:'+$(this).css('fontWeight')+';line-height:'+$(this).css('lineHeight')+';">'+$(this).html()+'</h3>');
            }
          });
          $('.why-consider-treatment-tagcloud2 .left-container-scroll').children(":first").addClass('left-cloud-tags');
          $('.left-cloud-tags').html('');

          $('.why-consider-treatment-tagcloud2 .right-container-scroll').find('h3').each(function(){
            if($(this).width() > 0){
              rightTags.push('<h3 style="color:'+$(this).css('color')+';font-size:22px;font-weight:'+$(this).css('fontWeight')+';line-height:'+$(this).css('lineHeight')+';">'+$(this).html()+'</h3>');
            }
          });
          $('.why-consider-treatment-tagcloud2 .right-container-scroll').children(":first").addClass('right-cloud-tags');
          $('.right-cloud-tags').html('');
      //}
      //if ($(window).width() <= 768){
          $('.why-consider-treatment-tagcloud2 .mobile-container-scroll').find('h3').each(function(){
            if($(this).width() > 0){
              mobileTags.push('<h3 style="color:'+$(this).css('color')+';font-weight:'+$(this).css('fontWeight')+';line-height:'+$(this).css('lineHeight')+';">'+$(this).html()+'</h3>');
            }
          });
          $('.why-consider-treatment-tagcloud2 .mobile-container-scroll').addClass('mobile-cloud-tags').css({'top':'0px'}).css({'alignItems':'center'}).css({'overflow':'hidden'}).css({'maxHeight':'600px'}).css({'justifyContent':'center'});
          $('.mobile-cloud-tags').html('');
        }
      }
      /*if($('.why-consider-treatment-tagcloud').length){
        if(!$('.why-consider-treatment-tagcloud').is(':hidden')){
          $('.why-consider-treatment-tagcloud .left-container-scroll').find('h3').each(function(){
            if($(this).width() > 0){
              leftTags.push('<h3 style="color:'+$(this).css('color')+';font-size:'+$(this).css('fontSize')+';font-weight:'+$(this).css('fontWeight')+';line-height:'+$(this).css('lineHeight')+';">'+$(this).html()+'</h3>');
            }
          });
          $('.why-consider-treatment-tagcloud .left-container-scroll').children(":first").addClass('left-cloud-tags');
          $('.left-cloud-tags').html('');
          $('.why-consider-treatment-tagcloud .right-container-scroll').find('h3').each(function(){
            if($(this).width() > 0){
              rightTags.push('<h3 style="color:'+$(this).css('color')+';font-size:'+$(this).css('fontSize')+';font-weight:'+$(this).css('fontWeight')+';line-height:'+$(this).css('lineHeight')+';">'+$(this).html()+'</h3>');
            }
          });
          $('.why-consider-treatment-tagcloud2 .right-container-scroll').children(":first").addClass('right-cloud-tags');
          $('.right-cloud-tags').html('');
        }
      }*/

      //}
      if ($(window).width() >= 1024){
        var ltagCloud = TagCloud('.left-cloud-tags', shuffle(leftTags),{
          // radius in px
          radius: 190,
          // animation speed
          // slow, normal, fast
          maxSpeed: 'slow',
          initSpeed: 'slow',
          // 0 = top
          // 90 = left
          // 135 = right-bottom
          direction: 135,
          // interact with cursor move on mouse out
          keep: false,
          useHTML: true,
        });
      
      //setTimeout(() => {
        var rtagCloud = TagCloud('.right-cloud-tags', shuffle(rightTags),{
          // radius in px
          radius: 190,
          // animation speed
          // slow, normal, fast
          maxSpeed: 'slow',
          initSpeed: 'slow',
          // 0 = top
          // 90 = left
          // 135 = right-bottom
          direction: 45,
          // interact with cursor move on mouse out
          keep: false,
          useHTML: true,
          reverseDirection: true,
        });
      //},2000);
      }
      if ($(window).width() < 1024){
        if($('.why-consider-treatment-section').length){
          if(!$('.why-consider-treatment-section').is(':hidden')){
            $('.why-consider-treatment-section .mobile-container-scroll').find('h3').each(function(){
              if($(this).width() > 0){
                mobileTags.push('<h3 style="color:'+$(this).css('color')+';font-weight:'+$(this).css('fontWeight')+';line-height:'+$(this).css('lineHeight')+';">'+$(this).html()+'</h3>');
              }
            });
            $('.why-consider-treatment-section .mobile-container-scroll').addClass('mobile-cloud-tags').css({'top':'0px'}).css({'alignItems':'center'}).css({'overflow':'hidden'}).css({'maxHeight':'600px'}).css({'justifyContent':'center'});
            $('.mobile-cloud-tags').html('');
          }
        }
      }
      var mobiletagCloud = [];
      var words_direction = 90;
      var parent_width = $('.mobile-cloud-tags').innerWidth() / 2;
      var text_size = '26px';
      console.log(parent_width);
      if ($(window).width() <= 768){
        $('.mobile-cloud-tags').css({'top':'-40px'});
        if($('.why-consider-treatment-tagcloud2').length){
          if(!$('.why-consider-treatment-tagcloud2').is(':hidden')){
            $('.why-consider-treatment-tagcloud2').css({'marginTop':'2rem'});
          }
        }
        if($('.why-consider-treatment-section').length){
          if(!$('.why-consider-treatment-section').is(':hidden')){
            $('.why-consider-treatment-section').css({'marginTop':'0rem'});
          }
        }
        text_size = '20px';
        words_direction = 90;
      }
      if(mobiletagCloud.length == 0){
        mobiletagCloud.push(TagCloud('.mobile-cloud-tags', mobileTags,{
          // radius in px
          radius: parent_width,
          // animation speed
          // slow, normal, fast
          maxSpeed: 'normal',
          initSpeed: 'normal',
          // 0 = top
          // 90 = left
          // 135 = right-bottom
          direction: words_direction,
          // interact with cursor move on mouse out
          keep: false,
          useHTML: true,
          reverseDirection: false,
        }));
      }
      $('.mobile-cloud-tags').find('.tagcloud--item').each(function(){
        $(this).find('h3').css({'fontSize':text_size});
      });

      $(window).resize(function() {
        //mobiletagCloud.destroy();
        if(mobiletagCloud.length > 0){
          var ltClouds = mobiletagCloud[mobiletagCloud.length - 1];
          if (ltClouds){
              ltClouds.destroy();
              mobiletagCloud.pop();
          }
        }
        if ($(window).width() <= 768){
          if($('.why-consider-treatment-tagcloud2').length){
            if(!$('.why-consider-treatment-tagcloud2').is(':hidden')){
              $('.why-consider-treatment-tagcloud2').css({'marginTop':'2rem'});
            }
          }
          if($('.why-consider-treatment-section').length){
            if(!$('.why-consider-treatment-section').is(':hidden')){
              $('.why-consider-treatment-section').css({'marginTop':'0rem'});
            }
          }
          $('.mobile-cloud-tags').css({'top':'-40px'}).css({'alignItems':'center'}).css({'maxHeight':'350px'}).css({'justifyContent':'center'});
          words_direction = 90;
          parent_width = $('.mobile-cloud-tags').innerWidth() / 2;
          text_size = '20px';
        }else{
          words_direction = 90;
          parent_width = $('.mobile-cloud-tags').innerWidth() / 2;
          text_size = '22px';
        }
        setTimeout(() => {
          //console.log(parent_width);
          if(mobiletagCloud.length == 0){
            mobiletagCloud.push(TagCloud('.mobile-cloud-tags', mobileTags,{
              // radius in px
              radius: parent_width,
              // animation speed
              // slow, normal, fast
              maxSpeed: 'normal',
              initSpeed: 'normal',
              // 0 = top
              // 90 = left
              // 135 = right-bottom
              direction: words_direction,
              // interact with cursor move on mouse out
              keep: false,
              useHTML: true,
              reverseDirection: false,
            }));
          }
          $('.mobile-cloud-tags').find('.tagcloud--item').each(function(){
            $(this).find('h3').css({'fontSize':text_size});
          });
          },200);
        });
      //if ($(window).width() <= 768){
        
        
      //}
      //To change the color of text randomly
      /*var colors = ['#34A853', '#FBBC05', '#4285F4', '#7FBC00', '#FFBA01', '#01A6F0'];
      var random_color = colors[Math.floor(Math.random() * colors.length)];
      document.querySelector('.left-cloud-tags').style.color = random_color;

      console.log(lefTags);*/
      //console.log(shuffle(rightTags));
      var scroll_delay = [400,300,600,700,500];
      var scroll_speed = [30000, 35000, 40000,45000,50000,55000,60000,65000];
      var scroll_dir = ['left', 'right', 'left','right','left','right','left','right'];
      setTimeout(() => {
      var el_width = $('.why-consider-treatment-section > .elementor-element > .e-con-inner');
      $(el_width).css({'position':'relative'});
      //console.log($(el_width).attr('class'));
      $('.why-consider-treatment-section').find('h3').each(function(){
          var $direction = Math.floor((Math.random() * 8));
          var el_speed = Math.floor((Math.random() * 8));
          var scroll_delay_idx = Math.floor((Math.random() * 5));

          //var $_translatex = $direction == 'right-left' ? 100 : -100;
          var $el_pos = scroll_dir[$direction];
          var $el_dir = $el_pos == 'right' ? -1161 : 1161;
          var $calc_pos = $(this).parent().parent().offset().left;
          //console.log($el_dir);
          //$(this).parent().parent().parent().css({'position':'static'}).parent().css({'position':'static'});
          $(this).parent().parent().css({'display':'inline'});
          $(this).parent().parent().css({'max-width':'unset'});
          setTimeout(() => {
            setInterval(() => {
              if($(this).parent().parent().parent().parent().hasClass('elementor-hidden-tablet') || $(this).parent().parent().parent().parent().hasClass('elementor-hidden-mobile')){
                  if($(this).width() > 0){
                    if($el_pos == 'right'){
                      //console.log('right el width: ',$(this).parent().parent().innerWidth());
                      //console.log('right: ',$(this).parent().parent().css('right'));
                      //console.log('left: ',$(this).parent().parent().css('left'));
                      //console.log('el width: ',$(el_width).offset().left);
                      if($(this).parent().parent().parent().parent().hasClass('left-container-scroll')){
                        $(this).parent().parent().animate({'left':'0px'}, scroll_speed[el_speed])
                        .animate({'left':(1140 - $(this).parent().parent().innerWidth())+'px'}, scroll_speed[el_speed]);
                      }else{
                        $(this).parent().parent().animate({'left':'-760px'}, scroll_speed[el_speed])
                        .animate({'left':(380 - $(this).parent().parent().innerWidth())+'px'}, scroll_speed[el_speed]);
                      }
                    }else{
                      //console.log('left el width: ',$(this).parent().parent().innerWidth());
                      //console.log('right: ',$(this).parent().parent().css('right'));
                      //console.log('left: ',$(this).parent().parent().css('left'));
                      //console.log('el width: ',$(el_width).offset().left);
                      if($(this).parent().parent().parent().parent().hasClass('left-container-scroll')){
                        $(this).parent().parent().animate({'left':(1140 - $(this).parent().parent().innerWidth())+'px'}, scroll_speed[el_speed])
                        .animate({'left':'0px'}, scroll_speed[el_speed]);
                      }else{
                        $(this).parent().parent().animate({'left':'-760px'}, scroll_speed[el_speed])
                        .animate({'left':(380 - $(this).parent().parent().innerWidth())+'px'}, scroll_speed[el_speed]);
                        $(this).parent().parent().css({'right':'auto'});
                      }
                    }
                  }
              /*setInterval(() => {
                if($el_pos == 'right'){
                  $calc_pos = $calc_pos - 1;
                }else{
                  $calc_pos = $calc_pos + 1;
                }
                
                console.log($calc_pos, ' ', $el_pos);
                $(this).parent().parent().css({'left': $calc_pos + 'px'})
              }, 1);*/

              //$(this).parent().parent().css({$el_pos: '0px'});
              //$(this).parent().parent().css({$reset_pos: 'unset'});
              /*$(this).parent().parent().css({'-moz-transform': 'translateX('+$_translatex + '%)'});
              $(this).parent().parent().css({'-webkit-transform': 'translateX('+$_translatex + '%'});
              $(this).parent().parent().css({'transform': 'translateX('+$_translatex + '%)'});
              $(this).parent().parent().css({'-moz-animation': $direction + ' 30s linear infinite alternate'});
              $(this).parent().parent().css({'-webkit-animation': $direction + ' 30s linear infinite alternate'});
              $(this).parent().parent().css({'animation': $direction + ' 30s linear infinite alternate'});*/
              //console.log($direction);
              /*var $scrollWidth =  $(this).parent().parent().outerWidth();
                $(this).parent().parent().css({$direction: -$scrollWidth + 'px'});
                function scroll() {
                  $(this).parent().parent().animate({
                    $direction: $width
                  }, 8000, 'linear', function() {
                    $(this).parent().parent().css({$direction: -$scrollWidth + 'px'});
                    scroll();
                  });
                }
                scroll();*/
              }
              /*if($(this).parent().parent().parent().parent().hasClass('elementor-hidden-desktop')){
                var $mobile_width = $(this).parent().parent().parent().innerWidth();
                if($(this).width() > 0){
                  if($el_pos == 'right'){
                    $(this).parent().parent().animate({'left':'0px'}, scroll_speed[el_speed])
                    .animate({'left':($mobile_width - $(this).parent().parent().innerWidth())+'px'}, scroll_speed[el_speed]);
                  }else{
                    $(this).parent().parent().animate({'left':($mobile_width - $(this).parent().parent().innerWidth())+'px'}, scroll_speed[el_speed])
                    .animate({'left':'0px'}, scroll_speed[el_speed]);
                  }
                }
              }*/
          },1);
        },scroll_delay[scroll_delay_idx]);
      });
    },5000);
      //console.log(Math.random());
    $(document).on('click', '.facility-filter-control-sc .selected-filer', function(e){
      e.preventDefault();
      //$(this).parent().parent().find('.filtiers').toggleClass('screen-hide-section');
      if($(this).parent().parent().find('.filtiers').hasClass('screen-hide-section')){
        $(this).parent().parent().find('.filtiers').removeClass('screen-hide-section');
        $('body').prepend('<div class="facility-filter-overlay"></div>');
      }else{
        $(this).parent().parent().find('.filtiers').addClass('screen-hide-section');
        $('.facility-filter-overlay').remove();
      }
    });
    $(document).on('click','.facility-filter-overlay', function(){
      $('.facility-filter-control-sc .selected-filer').click();
    });

    window.onkeyup = function (event) {
      if(event.keyCode == 27){
        //$('.facility-filter-control-sc .selected-filer').click();
        if(!$('.facility-filter-control-sc .filtiers').hasClass('screen-hide-section')){
          $('.facility-filter-control-sc .filtiers').addClass('screen-hide-section');
          $('.facility-filter-overlay').remove();
        }
      }
  }
  $('.what-we-treat-condition-section.clickable-container > .e-con-inner').find('.e-child').each(function(){
    $(this).on('click',function(e){
      e.preventDefault();
      var inner_link = $(this).find('a').attr('href');
      if(inner_link != '#'){
        location.href =  inner_link;
      }
    });
  });
  $(document).ready(function(){
    if($('.tm-info-container').length){
    var fixed_decimal = parseFloat($('.tm-info-container').parent().find('.go2299626625').eq(0).text());
    //console.log(fixed_decimal);
    $('.tm-info-container').parent().find('.go2299626625').html(fixed_decimal.toFixed(1));
    }
    if($('#desktopfacilitygallery2').length){
      $('#desktopfacilitygallery2 .facility-thumb-nails-style2').find('.swiper-slide').each(function(){
        $(this).find('img').css({'cursor':'pointer'});
        $(this).find('img').on({
          mouseenter: function () {
             $(this).css({'borderColor':'#D67E2B'});
          },
          mouseleave: function () {
            if(!$(this).hasClass('current-active')){
              $(this).css({'borderColor':''});
            }
          }
      });
        $(this).find('img').on('click',function(){
          //console.log($(this).attr('src'));
          var selected_image_parent = $(this).parent().parent().parent();
          selected_image_parent.find('img').removeClass('current-active');
          selected_image_parent.find('img').css({'borderColor':''});
          var selected_image = $(this);
          var clicked_facility_img_src = $(this).attr('src');
          var clicked_facility_img_src_set =  $(this).attr('srcset');
          $('#desktopfacilitygallery2 .facility-main-image-style2').find('img').fadeOut('fast', function () {
            $('#desktopfacilitygallery2 .facility-main-image-style2').find('img').attr('src',clicked_facility_img_src);
            $('#desktopfacilitygallery2 .facility-main-image-style2').find('img').attr('srcset',clicked_facility_img_src_set);
            $('#desktopfacilitygallery2 .facility-main-image-style2').find('img').fadeIn('fast');
            selected_image.css({'borderColor':'#D67E2B'});
            selected_image.addClass('current-active');
          });
        });
      });
    }
    if($('#marqueeContainer').length){
      const toLeftDir = [];
      const toRightDir = [];
      $('#marqueeToLeft').find('img').each(function(){
        toLeftDir.push($(this).parent().html());
      });
      $('#marqueeToLeft').html('');
      $.each(toLeftDir,function(idx, img){
        $('#marqueeToLeft').append(img);
      });

      $('#marqueeToRight').find('img').each(function(){
        toRightDir.push($(this).parent().html());
      });
      $('#marqueeToRight').html('');
      $.each(toRightDir,function(idx, img){
        $('#marqueeToRight').append(img);
      });

      $('#marqueeToLeft').marquee({
          direction:'left',
          duration: 100000,
          gap: 0,
          delayBeforeStart: 0,
          duplicated: true,
          startVisible: true
      });
      $('#marqueeToRight').marquee({
          direction:'right',
          duration: 100000,
          gap: 0,
          delayBeforeStart: 0,
          duplicated: true,
          startVisible: true
      });
    }
    if($('.facility-list-grid.clickable-container').length){
      $('.facility-list-grid.clickable-container .e-child').each(function(){
        $(this).on('click', function(){
          location.href = $(this).find('.elementor-widget-button').find('.elementor-widget-container').find('.elementor-button-wrapper').find('.elementor-button-link').attr('href');
        });
      });
    }
    if($('.mental-health-treatment-programs.clickable-container').length){
      $('.mental-health-treatment-programs.clickable-container .e-child').each(function(){
        $(this).on('click', function(){
          location.href = $(this).find('.elementor-widget-button').find('.elementor-widget-container').find('.elementor-button-wrapper').find('.elementor-button-link').attr('href');
        });
      });
    }
    if($('.elementor-widget-table-of-contents').length){
      if($(window).width() <= 768){

        /*$(window).on('scroll', function(){
            if($(window).scrollTop()<1)
          console.log($('#elementor-toc__heading-anchor-0').offset().top);
        });*/
      }
      $(document).on('click','.elementor-toc__top-level',function(e){
        e.preventDefault();
        var el_target_id = $(this).attr('href');
        //console.log($(el_target_id).offset().top);
        var el_target = $(el_target_id).offset().top;
        //console.log(el_target);
        $('.elementor-widget-table-of-contents').toggleClass('elementor-toc--collapsed');
        $('.elementor-toc__list-items--collapsible').toggle();
        $('html, body').animate({scrollTop:el_target}, 500);
      });
    }
  });
})(jQuery);